module.exports = __webpack_public_path__ + "media/site_templates/www.floor-sanding.net.au/images/our_services_3-62c0e1683bd726fd752729bc4626527c.jpg";